import React from 'react';
import styled from 'styled-components';

import { colors } from 'helpers/ColorHelper';
import { media } from 'helpers/MediaHelper';
import { getTranslatedString } from 'helpers/i18n';

const StyledInput = styled.input`
  border-radius: 25px;
  border: none;
  background-color: ${colors.DIALOG_BACKGROUND};
  font-size: 14px;
  padding: 5px 10px;
  width: 100%;
  max-width: 100%;
  &:focus {
    outline: none;
  }
  ${media.mobile`
    width: 100%;  
  `};
`;

export const SearchInput = ({
  accentColor = colors.ULTRAMARINE_BLUE,
  field,
  form,
  withButton,
  placeholder = 'Search term',
  handleChange,
  bgColor,
  ...props
}) => {
  const _handleChange = e => {
    handleChange(e);
  };
  return (
    <StyledInput
      placeholder={getTranslatedString('landlordPortal.filterAndSelect.searchAndSelect')}
      {...field}
      {...props}
      onChange={_handleChange}
    />
  );
};
